import { type RecipeComment } from '../../../api/Types';

interface CommentActionAccess {
  isAuthor: boolean;
  token: string | null;
}

interface UpdateCommentItemInput extends CommentActionAccess {
  commentId: number;
  editedComment: string;
  updateComment: (commentId: number, comment: string) => Promise<RecipeComment>;
}

interface DeleteCommentItemInput extends CommentActionAccess {
  commentId: number;
  confirmDelete: () => boolean;
  deleteComment: (commentId: number) => Promise<void>;
}

export const canManageComment = ({ isAuthor, token }: CommentActionAccess): boolean =>
  Boolean(token && isAuthor);

export const getCommentActionErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  if (
    error &&
    typeof error === 'object' &&
    'message' in error &&
    typeof error.message === 'string' &&
    error.message
  ) {
    return error.message;
  }

  return fallbackMessage;
};

export const updateCommentItem = async ({
  commentId,
  editedComment,
  isAuthor,
  token,
  updateComment,
}: UpdateCommentItemInput): Promise<RecipeComment | null> => {
  if (!canManageComment({ isAuthor, token })) {
    return null;
  }

  return updateComment(commentId, editedComment);
};

export const deleteCommentItem = async ({
  commentId,
  confirmDelete,
  deleteComment,
  isAuthor,
  token,
}: DeleteCommentItemInput): Promise<boolean> => {
  if (!canManageComment({ isAuthor, token }) || !confirmDelete()) {
    return false;
  }

  await deleteComment(commentId);
  return true;
};
